/*
 * Project: forca
 * File Created: Monday, 8th November 2021 1:02:50 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import TextDeck from './textDeck.component';

export const TextDeckContainer = (props: any) => {
	const containerProps = () => {
		const { currentBlock = null } = props;

		if (!currentBlock) {
			return props;
		}

		const {
			textDeckElementList,
			currentBlock: {
				overskrift,
				elementMargin
			}
		} = props;

		const boxes = [];

		if (textDeckElementList.length > 0) {
			textDeckElementList.map(item => {
				item = item.currentBlock;

				boxes.push({
					title: item.title,
					subtitle: item.subtitle,
					content: item.content,
					titleSeperator: item.showTitleSeparator
				});
			});
		}

		return {
			title: overskrift,
			boxes,
			elementMargin
		};
	};

	return (
		<TextDeck
			{ ...containerProps() }
		/>
	);
};

export default TextDeckContainer;